(function () {
  const raw = document.getElementById('ir-lp-data');
  if (!raw) return;
  const data = JSON.parse(raw.textContent);
  if (!data) return;

  const state = {
    productId: data.product.id,
    imageIndex: 0,
    size: null,
    cart: null,
    checkoutNote: false,
    upsellId: null
  };

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  /* ── helpers ── */

  function slug(name) {
    return String(name || '').toLowerCase().replace(/^the\s+/, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function money(n) {
    return '$' + Number(n).toFixed(2);
  }

  function starSvg() {
    return '<svg class="star" viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M10 1.5 12.6 7l6 .5-4.6 4 1.4 5.8L10 14.8 4.6 17.3 6 11.5 1.4 7.5l6-.5L10 1.5z"/></svg>';
  }

  function stars(rating) {
    const filled = Math.max(0, Math.min(5, Number(rating) || 0));
    const icons = Array.from({ length: 5 }, (_, i) =>
      `<span class="${i < filled ? '' : 'star-empty'}">${starSvg()}</span>`
    ).join('');
    return `<span class="stars" aria-label="${filled} out of 5 stars">${icons}</span>`;
  }

  function truckIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 7h11v8H3zM14 11h4l3 3v1h-7z"/><circle cx="7" cy="18" r="1.4" fill="currentColor" stroke="none"/><circle cx="18" cy="18" r="1.4" fill="currentColor" stroke="none"/></svg>';
  }

  function checkIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7.5"/></svg>';
  }

  /* ── catalog ── */

  function catalog() {
    return (data.catalog || []).map(style => ({
      id: style.id || slug(style.name),
      name: style.name,
      price: style.priceValue ?? Number(String(style.price).replace(/[^0-9.]/g, '')),
      src: style.src,
      alt: style.alt,
      color: style.color || '',
      finish: style.finish || '',
      width: style.width || '7mm',
      collection: style.collection || '',
      gallery: style.gallery
    }));
  }

  function catalogItem(id) {
    return catalog().find(item => item.id === id);
  }

  function currentProduct() {
    return catalogItem(state.productId) || catalog()[0];
  }

  function variantId(productId, size) {
    return data.shopify?.variants?.[productId]?.[String(size)] || null;
  }

  function canBuy(productId, size) {
    return !!variantId(productId, size) && !(data.shopify?.soldOut?.[productId] || []).includes(String(size));
  }

  // Each ring's own sizes (from its variants), smallest first.
  function sizesFor(productId) {
    const own = Object.keys(data.shopify?.variants?.[productId] || {});
    return own.length ? own.sort((a, b) => parseFloat(a) - parseFloat(b)) : (data.product.sizes || []);
  }

  function availableSizes(productId) {
    return sizesFor(productId).filter(size => canBuy(productId, size));
  }

  function markSoldOut(productId, size) {
    const shop = data.shopify || (data.shopify = {});
    const soldOut = shop.soldOut || (shop.soldOut = {});
    const list = soldOut[productId] || (soldOut[productId] = []);
    if (!list.includes(String(size))) list.push(String(size));
  }

  function showError(el, message) {
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
  }

  function hideError(el) {
    el?.classList.remove('is-visible');
  }

  function focusFirstSize() {
    $('#size-grid input:not(:disabled)')?.focus();
  }

  function shopifyProductId(productId) {
    return data.shopify?.products?.[productId] || null;
  }

  /* ── gallery ── */

  function galleryFile(img) {
    return String(img?.src || '').split('?')[0].split('/').pop().toLowerCase();
  }

  function isFocusedProductShot(img) {
    const file = galleryFile(img);
    if (/\.jpe?g$/.test(file) || /\.webp$/.test(file)) return false;
    if (/cutout|usp|stand/.test(file)) return true;
    const numbered = file.match(/-(\d+)\.png$/);
    if (numbered) return Number(numbered[1]) % 2 === 1;
    return /\.png$/.test(file);
  }

  function mixGallery(images) {
    if (images.length < 3) return images;
    const [hero, ...rest] = images;
    const product = rest.filter(isFocusedProductShot);
    const lifestyle = rest.filter(img => !isFocusedProductShot(img));
    const mixed = [hero];
    let p = 0, l = 0, takeLife = true;
    while (p < product.length || l < lifestyle.length) {
      if (takeLife && l < lifestyle.length) mixed.push(lifestyle[l++]);
      else if (!takeLife && p < product.length) mixed.push(product[p++]);
      else if (l < lifestyle.length) mixed.push(lifestyle[l++]);
      else mixed.push(product[p++]);
      takeLife = !takeLife;
    }
    return mixed;
  }

  function productGallery(item) {
    const raw = item.gallery?.length
      ? item.gallery
      : (data.gallery?.length ? data.gallery : [{ src: item.src, alt: item.alt, w: 1600, h: 1600 }]);
    return mixGallery(raw.filter(img => img?.src));
  }

  function showGalleryImage(index) {
    const images = productGallery(currentProduct());
    if (!images.length) return;
    const len = images.length;
    state.imageIndex = ((index % len) + len) % len;
    renderGallery();
  }

  function renderGallery() {
    const main = $('#gallery-main-image');
    const thumbs = $('#gallery-thumbs');
    const images = productGallery(currentProduct());
    if (!images.length) return;
    if (state.imageIndex >= images.length) state.imageIndex = 0;
    const current = images[state.imageIndex];
    main.src = current.src;
    main.alt = current.alt || '';
    main.width = current.w || 1600;
    main.height = current.h || 1600;
    main.style.transform = '';
    main.classList.toggle('is-hero-zoom', state.imageIndex === 0);
    thumbs.innerHTML = images.map((img, i) => {
      const active = i === state.imageIndex ? ' aria-current="true"' : '';
      return `<button type="button" aria-label="View image ${i + 1}"${active} data-index="${i}"><img src="${img.src}" alt="" width="88" height="88"></button>`;
    }).join('');
    thumbs.querySelectorAll('button[data-index]').forEach(btn => {
      btn.addEventListener('click', () => showGalleryImage(Number(btn.dataset.index)));
    });
    thumbs.querySelectorAll('img').forEach(img => {
      img.addEventListener('error', () => img.closest('button')?.remove());
    });
    const activeBtn = thumbs.querySelector('button[aria-current="true"]');
    if (activeBtn) {
      const left = activeBtn.offsetLeft - thumbs.clientWidth / 2 + activeBtn.clientWidth / 2;
      thumbs.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
  }

  function extraShots(item) {
    const images = productGallery(item);
    const extra = images.filter((img, i) => i > 0 && !/stand-cutout/.test(img.src));
    return extra.length ? extra : images;
  }

  function scene(item, index) {
    const images = extraShots(item);
    const jpgs = images.filter(img => /\.jpe?g$/i.test(img.src));
    const pool = jpgs.length ? jpgs : images;
    return pool[index % pool.length];
  }

  function companionStyle(item) {
    const all = catalog();
    return (
      all.find(s => s.id !== item.id && s.collection !== item.collection) ||
      all.find(s => s.id !== item.id) ||
      item
    );
  }

  /* ── page state ── */

  function personalize(text, item) {
    return String(text || '').replaceAll('The Storm', item.name);
  }

  function setBind(key, value) {
    $$(`[data-bind="${key}"]`).forEach(el => { el.textContent = value; });
  }

  function setImg(sel, img) {
    const el = $(sel);
    if (!el || !img) return;
    el.src = img.src;
    if (img.alt != null) el.alt = img.alt;
    if (img.w) el.width = img.w;
    if (img.h) el.height = img.h;
  }

  function updatePage() {
    const item = currentProduct();
    const price = money(item.price);
    const companion = companionStyle(item);
    const setText = (sel, value) => { const el = $(sel); if (el) el.textContent = value; };

    setBind('name', item.name);
    setBind('price', price);
    setText('#product-title', item.name);
    setText('#buy-price', price);
    setText('#variant-name', item.name);
    setText('#sticky-name', item.name);
    setText('#sticky-price', price);
    setText('#finish-callout', `${item.finish || 'Polished'}, ${item.width || '7mm'} width.`);

    $$('.variant-btn').forEach(btn => {
      const selected = btn.dataset.variant === item.id;
      btn.setAttribute('aria-selected', selected ? 'true' : 'false');
      if (selected) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });

    document.title = `${item.name} | Premium Without the $500 Price Tag | Iconic Rings`;

    const quality = { src: item.src, alt: `${item.name} tungsten ring, isolated`, w: 1600, h: 1600 };
    setImg('#quality-hero-img', quality);
    setImg('#tryon-card-img', scene(item, 0) || { src: item.src, alt: item.alt });
    setImg('#value-img', scene(item, 0) || { src: item.src, alt: item.alt });
    setImg('#contrast-img', scene(item, 1) || scene(item, 0));
    setImg('#risk-img', scene(item, 2) || scene(item, 0));
    setImg('#faq-img', scene(item, 3) || scene(item, 1) || scene(item, 0));
    setImg('#bundle-a-img', { src: item.src, alt: item.alt });
    setImg('#bundle-b-img', { src: companion.src, alt: companion.alt });
    setImg('#bundle-card-img', { src: companion.src, alt: companion.alt });

    renderProofReviews();
    renderPhotoReviews();
    renderFaqs();
  }

  /* ── variants & sizes ── */

  function renderVariants() {
    const root = $('#variant-picker');
    if (!root) return;
    root.innerHTML = catalog().map(item =>
      `<button class="variant-btn" type="button" role="option" data-variant="${item.id}" aria-selected="${item.id === state.productId ? 'true' : 'false'}"${item.id === state.productId ? ' aria-current="true"' : ''} aria-label="${item.name}, ${money(item.price)}" title="${item.name}">
        <img src="${item.src}" alt="" width="120" height="120">
      </button>`
    ).join('');
  }

  function selectVariant(id) {
    if (!catalogItem(id) || id === state.productId) return;
    const prevSize = state.size;
    state.productId = id;
    state.imageIndex = 0;
    updatePage();
    renderGallery();
    renderSizes();
    updateSelectedSize();
    if (prevSize && !state.size) showError($('#size-error'), `Size ${prevSize} is sold out in ${currentProduct().name}. Please choose another size.`);
    else hideError($('#size-error'));
    trackViewContent();
  }

  function initVariants() {
    $('#variant-picker')?.addEventListener('click', e => {
      const btn = e.target.closest('[data-variant]');
      if (!btn) return;
      selectVariant(btn.dataset.variant);
    });
  }

  function renderSizes() {
    const root = $('#size-grid');
    if (!root) return;
    const id = currentProduct().id;
    if (state.size && !canBuy(id, state.size)) state.size = null;
    root.innerHTML = sizesFor(id).map(size => {
      const key = size.replace('.', '-');
      const soldOut = !canBuy(id, size);
      return `<input type="radio" name="ring-size" id="size-${key}" value="${size}"${soldOut ? ' disabled' : ''}${size === state.size ? ' checked' : ''}>
       <label for="size-${key}"${soldOut ? ' title="Sold out"' : ''}>${size}${soldOut ? '<span class="visually-hidden"> (sold out)</span>' : ''}</label>`;
    }).join('');
  }

  function renderSizeTable() {
    const body = $('#size-table-body');
    if (!body) return;
    body.innerHTML = (data.product.sizeChart || []).map(row =>
      `<tr><td>${row.mm} mm</td><td>${row.size}</td></tr>`
    ).join('');
  }

  function updateSelectedSize() {
    const label = state.size ? `· Selected: ${state.size}` : '';
    $$('[data-selected-size]').forEach(el => { el.textContent = label; });
    const el = $('#sticky-size');
    if (el) el.textContent = state.size ? `Size ${state.size}` : 'Select a size';
  }

  function initSizes() {
    $('#size-grid')?.addEventListener('change', e => {
      if (e.target.name !== 'ring-size') return;
      state.size = e.target.value;
      $('#size-error')?.classList.remove('is-visible');
      updateSelectedSize();
    });
  }

  function sizeOptions(selected, productId) {
    const options = sizesFor(productId).map(size => {
      const soldOut = productId && !canBuy(productId, size);
      return `<option value="${size}"${size === selected && !soldOut ? ' selected' : ''}${soldOut ? ' disabled' : ''}>${size}${soldOut ? ' (sold out)' : ''}</option>`;
    }).join('');
    return selected ? options : `<option value="" selected disabled>Choose size</option>${options}`;
  }

  function pickSize(productId, ...preferred) {
    return preferred.find(size => size && canBuy(productId, size)) || null;
  }

  /* ── ratings & reviews ── */

  function renderRatingSummary() {
    const total = data.product.reviewCount || 1;
    const ratingEl = $('#rating-number');
    const countEl = $('#rating-count');
    if (ratingEl) ratingEl.textContent = `${data.product.rating}/5`;
    if (countEl) countEl.textContent = `${total} reviews`;
    const bars = $('#rating-bars');
    if (!bars) return;
    bars.innerHTML = (data.ratingBreakdown || []).map(row => {
      const pct = Math.round((row.count / total) * 100);
      return `<div class="bar-row">
        <span>${row.stars} star</span>
        <div class="bar-track" aria-hidden="true"><div class="bar-fill" style="width:${pct}%"></div></div>
        <span>${pct}%</span>
      </div>`;
    }).join('');
  }

  function renderProofReviews() {
    const root = $('#proof-reviews');
    if (!root) return;
    const item = currentProduct();
    root.innerHTML = (data.reviews || []).map(review => {
      const date = review.date ? ` · ${review.date}` : '';
      return `<article class="review-row">
        ${stars(review.rating)}
        <h3>${personalize(review.title, item)}</h3>
        <p class="meta">${review.name} · Size ${review.size}${date}</p>
        <p>${personalize(review.body, item)}</p>
      </article>`;
    }).join('');
  }

  function renderPhotoReviews() {
    const root = $('#proof-photos');
    if (!root) return;
    const item = currentProduct();
    const extras = extraShots(item);
    const jpgs = extras.filter(img => /\.jpe?g$/i.test(img.src));
    const photos = jpgs.length >= 3
      ? jpgs.slice(0, 6).map(img => ({ src: img.src, alt: `Photo of ${item.name}` }))
      : (data.photoReviews || []);
    root.innerHTML = (photos.length ? photos : extras.slice(0, 6)).map(img =>
      `<button type="button" aria-label="${img.alt}">
        <img src="${img.src}" alt="${img.alt}" width="200" height="200" loading="lazy">
      </button>`
    ).join('');
  }

  /* ── accordions & FAQs ── */

  function renderAccordions(containerId, items, key) {
    const root = $(containerId);
    if (!root) return;
    root.innerHTML = items.map((item, i) => {
      const id = `${key}-${item.id || i}`;
      const title = item.title || item.q;
      const html = item.html || `<p>${item.a}</p>`;
      return `<div class="accordion">
        <h3>
          <button class="accordion__trigger" type="button" aria-expanded="false" aria-controls="${id}" id="${id}-btn">
            <span>${title}</span>
            <svg class="accordion__icon" viewBox="0 0 12 12" aria-hidden="true"><path d="M1 4l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>
          </button>
        </h3>
        <div class="accordion__panel" id="${id}" role="region" aria-labelledby="${id}-btn">${html}</div>
      </div>`;
    }).join('');
  }

  function renderFaqs() {
    const item = currentProduct();
    const faqs = (data.faqs || []).map(faq => ({ q: faq.q, a: personalize(faq.a, item) }));
    renderAccordions('#faq-accordions', faqs, 'faq');
  }

  function initAccordions() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.accordion__trigger');
      if (!btn) return;
      const item = btn.closest('.accordion');
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      item.classList.toggle('is-open', !open);
    });
  }

  /* ── announcement bar ── */

  function initAnnouncement() {
    const items = $$('.announcement__item');
    if (items.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  }

  /* ── gallery swipe ── */

  function initGallery() {
    $('#gallery-thumbs')?.addEventListener('click', e => {
      const btn = e.target.closest('button[data-index]');
      if (!btn) return;
      showGalleryImage(Number(btn.dataset.index));
    });

    const stage = $('#gallery-main');
    const img = $('#gallery-main-image');
    if (!stage || !img) return;

    const swipe = { tracking: false, axis: null, startX: 0, startY: 0, dx: 0 };

    function resetSwipe() {
      swipe.tracking = false; swipe.axis = null; swipe.dx = 0;
      stage.classList.remove('is-dragging');
      img.style.transform = '';
    }

    stage.addEventListener('pointerdown', e => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (productGallery(currentProduct()).length < 2) return;
      swipe.tracking = true; swipe.axis = null;
      swipe.startX = e.clientX; swipe.startY = e.clientY; swipe.dx = 0;
      stage.classList.add('is-dragging');
      try { stage.setPointerCapture(e.pointerId); } catch (_) {}
    });

    stage.addEventListener('pointermove', e => {
      if (!swipe.tracking) return;
      const dx = e.clientX - swipe.startX;
      const dy = e.clientY - swipe.startY;
      if (!swipe.axis) {
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
        swipe.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (swipe.axis === 'y') { resetSwipe(); return; }
      }
      if (swipe.axis !== 'x') return;
      swipe.dx = dx;
      img.style.transform = `translateX(${dx}px)`;
    });

    function finishSwipe() {
      if (!swipe.tracking) return;
      const dx = swipe.dx;
      const horizontal = swipe.axis === 'x';
      resetSwipe();
      if (!horizontal || Math.abs(dx) < 46) return;
      showGalleryImage(state.imageIndex + (dx < 0 ? 1 : -1));
    }

    stage.addEventListener('pointerup', finishSwipe);
    stage.addEventListener('pointercancel', resetSwipe);
    stage.addEventListener('lostpointercapture', () => { if (swipe.tracking) finishSwipe(); });
    stage.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); showGalleryImage(state.imageIndex + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); showGalleryImage(state.imageIndex - 1); }
    });
  }

  /* ── focus trap ── */

  function trapFocus(container) {
    function getFocusable() {
      return $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', container)
        .filter(el => !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true');
    }
    function onKey(e) {
      if (e.key !== 'Tab') return;
      const focusable = getFocusable();
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return () => container.removeEventListener('keydown', onKey);
  }

  let releaseModalFocus = null, lastFocus = null;

  function openModal(id, focusSel) {
    const modal = $(id);
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    const focusEl = (focusSel && $(focusSel, modal)) || $('.modal__close', modal);
    releaseModalFocus = trapFocus(modal);
    focusEl?.focus({ preventScroll: true });
  }

  function closeModal(id) {
    const modal = $(id);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (releaseModalFocus) releaseModalFocus();
    if (lastFocus) lastFocus.focus();
  }

  function initModal() {
    $('#open-size-guide')?.addEventListener('click', () => openModal('#size-guide'));
    $$('#size-guide [data-close-modal]').forEach(el => el.addEventListener('click', () => closeModal('#size-guide')));
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      if ($('#upsell-modal')?.classList.contains('is-open')) { skipUpsell(); return; }
      if ($('#size-guide')?.classList.contains('is-open')) closeModal('#size-guide');
      if ($('#cart-drawer')?.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ── Shopify AJAX cart ── */

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  // Same line property the product page's "7-Day Risk-Free Try-On" button sets.
  const TRY_ON = { purchase_type: 'pay_later' };
  const isTryOn = item => item.properties?.purchase_type === 'pay_later';
  // A second ring from the bundle offers is a try-on too when the cart already holds a try-on ring.
  const followTryOn = () => ((state.cart?.items || []).some(isTryOn) ? TRY_ON : undefined);

  async function cartAdd(variantId, qty = 1, properties) {
    const item = { id: variantId, quantity: qty };
    if (properties) item.properties = properties;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
    if (!res.ok) {
      const err = new Error('Add to cart failed');
      err.status = res.status;
      throw err;
    }
    return getCart();
  }

  async function cartChange(lineKey, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    });
    if (!res.ok) throw new Error('Cart change failed');
    return res.json();
  }

  function unitCount() {
    return state.cart?.item_count || 0;
  }

  function updateCartCount() {
    const countEl = $('#cart-count');
    if (!countEl) return;
    const n = unitCount();
    countEl.textContent = String(n);
    countEl.classList.toggle('is-visible', n > 0);
  }

  function renderShippingBar(animate) {
    const bar = $('#cart-shipping');
    if (!bar) return;
    const fill = $('.ship-bar__fill', bar);
    const track = $('.ship-bar__track', bar);
    const msg = $('#cart-shipping-msg');
    const unlocked = unitCount() > 0;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    bar.dataset.unlocked = String(unlocked);
    track?.setAttribute('aria-valuenow', unlocked ? '100' : '12');
    if (msg) msg.innerHTML = unlocked
      ? `<span class="ship-bar__icon">${checkIcon()}</span><span>You got free shipping</span>`
      : `<span class="ship-bar__icon">${truckIcon()}</span><span>Add a ring to unlock free shipping</span>`;
    if (!fill) return;
    if (unlocked && animate && !reduceMotion) {
      fill.style.transition = 'none';
      fill.style.width = '12%';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        fill.style.transition = '';
        fill.style.width = '100%';
      }));
    } else {
      fill.style.transition = '';
      fill.style.width = unlocked ? '100%' : '12%';
    }
  }

  function renderCartLines() {
    const items = state.cart?.items || [];
    if (!items.length) return '';
    return items.map(item => {
      const size = item.variant_title || item.options_with_values?.[0]?.value || '';
      const imgSrc = item.image || item.featured_image?.url || '';
      return `<article class="cart-line" data-line="${item.key}">
        <div class="cart-line__img">
          <img src="${imgSrc}" alt="${item.product_title}" width="160" height="160">
        </div>
        <div class="cart-line__info">
          <div class="cart-line__top">
            <h3 class="cart-line__name">${item.product_title}</h3>
            <span class="cart-line__price">${money(item.price / 100)}</span>
          </div>
          <p class="cart-line__meta">${size ? `Size ${size} · ` : ''}Tungsten carbide</p>
          ${isTryOn(item) ? '<p class="lp-line-tryon">7-day at-home try-on</p>' : ''}
          <div class="cart-line__actions">
            <div class="qty">
              <button type="button" data-qty="-1" aria-label="Decrease quantity">−</button>
              <span aria-live="polite">${item.quantity}</span>
              <button type="button" data-qty="1" aria-label="Increase quantity">+</button>
            </div>
            <button class="cart-line__remove" type="button" data-remove>Remove</button>
          </div>
        </div>
      </article>`;
    }).join('');
  }

  function renderUpsell() {
    const items = state.cart?.items || [];
    if (!items.length) return '';
    if (items.length >= 2) {
      return `<div class="cart-applied">
        ${checkIcon()}
        <p>
          <strong>Second ring 40% off at checkout</strong>
          <span>Discount applied automatically. No code required.</span>
        </p>
      </div>`;
    }
    const inCart = new Set(items.map(i => (i.handle || '').replace(/^the-/, '')));
    const defaultSize = state.size || items[0]?.variant_title || (data.product.sizes || [])[4] || '9';
    const styles = (data.secondStyles || [])
      .map(style => catalogItem(style.id || slug(style.name)))
      .filter(style => style && !inCart.has(style.id) && availableSizes(style.id).length);
    if (!styles.length) return '';
    const cards = styles.map(style => {
      const sale = (style.price * 0.6).toFixed(2);
      return `<article class="cart-upsell__card" data-upsell-card="${style.id}">
        <img src="${style.src}" alt="${style.alt}" width="120" height="120">
        <div class="cart-upsell__copy">
          <strong>${style.name}</strong>
          <div class="cart-upsell__prices">
            <span class="cart-upsell__was">${money(style.price)}</span>
            <span class="cart-upsell__now">$${sale}</span>
          </div>
          <div class="cart-upsell__row">
            <label for="upsell-size-${style.id}">Size</label>
            <select id="upsell-size-${style.id}" data-upsell-size="${style.id}" aria-label="Size for ${style.name}">
              ${sizeOptions(pickSize(style.id, defaultSize), style.id)}
            </select>
            <button class="btn cart-upsell__add" type="button" data-add-upsell="${style.id}">Add · 40% off</button>
          </div>
          <p class="size-error" data-upsell-error="${style.id}" role="alert"></p>
        </div>
      </article>`;
    }).join('');
    return `<aside class="cart-upsell">
      <p class="cart-upsell__label">Bundle offer</p>
      <h3>Add a second ring for 40% OFF</h3>
      <p>No code required. Discount applied at checkout.</p>
      <div class="cart-upsell__grid">${cards}</div>
    </aside>`;
  }

  function renderCartBody() {
    if (!state.cart?.items?.length) {
      return `<div class="cart-empty">
        <h3>Your cart is empty</h3>
        <p>Add ${currentProduct().name} to unlock free shipping. Add a second ring and save 40%.</p>
        <button class="btn btn--ghost btn--full" type="button" data-close-drawer data-scroll-to-size>Select a size</button>
      </div>`;
    }
    return `${renderCartLines()}${renderUpsell()}`;
  }

  function tryOnNote() {
    const n = (state.cart?.items || []).filter(isTryOn).reduce((sum, i) => sum + i.quantity, 0);
    if (!n) return '';
    return `<p class="lp-cart-tryon">7-day at-home try-on: we authorize your card at checkout, and you’re only charged if you keep ${n === 1 ? 'your ring' : 'your rings'}.</p>`;
  }

  function renderCartFoot() {
    if (!state.cart?.items?.length) {
      return `<p class="cart-note">Add a ring to check out on iconic-rings.com.</p>`;
    }
    const subtotal = (state.cart.total_price / 100);
    const count = state.cart.item_count;
    const noteText = count >= 2
      ? '40% off your second ring will be applied at checkout. Free shipping on every order.'
      : "You'll complete your order on iconic-rings.com. Free shipping on every order.";
    return `<div class="cart-totals">
      <div class="cart-totals__row"><span>Subtotal</span><span>${money(subtotal)}</span></div>
      <div class="cart-totals__row cart-totals__row--ship"><span>Shipping</span><span class="cart-totals__free">Free</span></div>
      <div class="cart-totals__row cart-totals__row--total"><span>Total</span><strong>${money(subtotal)}</strong></div>
    </div>
    ${tryOnNote()}
    <button class="btn btn--full" type="button" data-checkout>Checkout</button>
    <p class="cart-note">${noteText}</p>
    <button class="cart-continue" type="button" data-close-drawer>Continue shopping</button>`;
  }

  function renderCart({ animateShip = false } = {}) {
    const count = unitCount();
    const titleEl = $('#cart-title');
    if (titleEl) titleEl.textContent = count === 1 ? '1 item' : `${count} items`;
    const bodyEl = $('#cart-body');
    if (bodyEl) bodyEl.innerHTML = renderCartBody();
    const footEl = $('#cart-foot');
    if (footEl) footEl.innerHTML = renderCartFoot();
    renderShippingBar(animateShip);
    updateCartCount();
  }

  let releaseCartFocus = null, lastCartFocus = null;

  function openDrawer({ animateShip = false } = {}) {
    const drawer = $('#cart-drawer');
    const alreadyOpen = drawer.classList.contains('is-open');
    renderCart({ animateShip });
    if (alreadyOpen) return;
    lastCartFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    releaseCartFocus = trapFocus(drawer);
    $('.drawer__close', drawer)?.focus();
  }

  function closeDrawer() {
    const drawer = $('#cart-drawer');
    drawer.classList.remove('is-open');
    drawer.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (releaseCartFocus) releaseCartFocus();
    if (lastCartFocus) lastCartFocus.focus();
  }

  async function addToCart(tryOn = false) {
    const error = $('#size-error');
    if (!state.size) {
      showError(error, 'Please choose your ring size.');
      focusFirstSize();
      return;
    }
    const product = currentProduct();
    const size = state.size;
    if (!canBuy(product.id, size)) {
      showError(error, `Size ${size} is sold out in ${product.name}. Please choose another size.`);
      return;
    }
    const vid = variantId(product.id, size);
    const wasEmpty = unitCount() === 0;
    try {
      state.cart = await cartAdd(vid, 1, tryOn ? TRY_ON : undefined);
      trackTripleAdd(product.id, state.size, 1);
      if (wasEmpty && upsellPicks().length) {
        openUpsell();
      } else {
        openDrawer({ animateShip: wasEmpty });
      }
    } catch (e) {
      if (e.status === 422) {
        markSoldOut(product.id, size);
        renderSizes();
        updateSelectedSize();
        showError(error, `Sorry, size ${size} in ${product.name} just sold out. Please choose another size.`);
      } else {
        showError(error, 'Something went wrong adding this to your cart. Please try again.');
      }
    }
  }

  async function setQty(lineKey, newQty) {
    try {
      state.cart = await cartChange(lineKey, newQty);
      renderCart();
      updateCartCount();
    } catch (e) {
      console.error('Cart change error:', e);
    }
  }

  async function goToCheckout() {
    const btn = $('#cart-foot [data-checkout]');
    if (btn) { btn.disabled = true; btn.textContent = 'Going to checkout…'; }
    shareMetaCookies();
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { landing_page: 'value' } })
      });
    } catch (e) {}
    window.location.href = '/checkout';
  }

  function initCart() {
    $$('[data-add-to-cart]').forEach(btn => btn.addEventListener('click', () => addToCart(btn.hasAttribute('data-try-on'))));
    $$('[data-open-cart]').forEach(el => el.addEventListener('click', () => openDrawer()));
    const drawer = $('#cart-drawer');
    drawer?.addEventListener('click', async e => {
      const closeBtn = e.target.closest('[data-close-drawer]');
      if (closeBtn) {
        const scrollToSize = closeBtn.hasAttribute('data-scroll-to-size');
        closeDrawer();
        if (scrollToSize) {
          const target = $('#size-selector');
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          focusFirstSize();
        }
        return;
      }
      const line = e.target.closest('[data-line]');
      if (line) {
        const qtyBtn = e.target.closest('[data-qty]');
        if (qtyBtn) {
          const lineItem = state.cart?.items?.find(i => i.key === line.dataset.line);
          if (!lineItem) return;
          await setQty(lineItem.key, lineItem.quantity + Number(qtyBtn.dataset.qty));
          return;
        }
        if (e.target.closest('[data-remove]')) {
          const lineItem = state.cart?.items?.find(i => i.key === line.dataset.line);
          if (lineItem) await setQty(lineItem.key, 0);
          return;
        }
      }
      const upsellBtn = e.target.closest('[data-add-upsell]');
      if (upsellBtn) {
        const style = catalogItem(upsellBtn.dataset.addUpsell);
        if (!style) return;
        const sizeVal = $(`[data-upsell-size="${style.id}"]`)?.value;
        const cardError = () => $(`[data-upsell-error="${style.id}"]`);
        if (!sizeVal) {
          showError(cardError(), `Please choose a size for ${style.name}.`);
          return;
        }
        if (!canBuy(style.id, sizeVal)) {
          showError(cardError(), `Size ${sizeVal} is sold out in ${style.name}. Please choose another size.`);
          return;
        }
        try {
          state.cart = await cartAdd(variantId(style.id, sizeVal), 1, followTryOn());
          renderCart({ animateShip: false });
        } catch (e) {
          if (e.status === 422) markSoldOut(style.id, sizeVal);
          renderCart({ animateShip: false });
          showError(cardError(), e.status === 422
            ? `Sorry, size ${sizeVal} in ${style.name} just sold out. Please choose another size.`
            : 'Something went wrong. Please try again.');
        }
        return;
      }
      if (e.target.closest('[data-checkout]')) goToCheckout();
    });
    drawer?.addEventListener('change', e => {
      const select = e.target.closest('[data-upsell-size]');
      if (select) hideError($(`[data-upsell-error="${select.dataset.upsellSize}"]`));
    });
  }

  /* ── upsell modal ── */

  function upsellPicks() {
    const current = currentProduct();
    const inCart = new Set((state.cart?.items || []).map(i => (i.handle || '').replace(/^the-/, '')));
    const picks = [];
    const add = item => {
      if (!item || inCart.has(item.id) || picks.some(p => p.id === item.id) || !availableSizes(item.id).length) return;
      picks.push(item);
    };
    add(companionStyle(current));
    (data.secondStyles || []).forEach(style => add(catalogItem(style.id || slug(style.name))));
    catalog().forEach(add);
    return picks;
  }

  function selectedUpsell() {
    return catalogItem(state.upsellId) || upsellPicks()[0];
  }

  function syncUpsellSelection() {
    const first = currentProduct();
    const second = selectedUpsell();
    if (!second) return;
    const save = (Math.min(first.price, second.price) * 0.4).toFixed(2);
    const sale = (second.price * 0.6).toFixed(2);
    setImg('#upsell-first-img', { src: first.src, alt: first.alt });
    setImg('#upsell-second-img', { src: second.src, alt: second.alt });
    const badge = $('#upsell-save');
    if (badge) badge.textContent = `Save $${save}`;
    $$('#upsell-picks [data-upsell-pick]').forEach(btn => {
      btn.setAttribute('aria-selected', btn.dataset.upsellPick === second.id ? 'true' : 'false');
    });
    const sizeSel = $('#upsell-size');
    const chosen = sizeSel ? pickSize(second.id, sizeSel.value, state.size) : null;
    if (sizeSel) sizeSel.innerHTML = sizeOptions(chosen, second.id);
    if (!chosen && state.size) showError($('#upsell-error'), `Size ${state.size} is sold out in ${second.name}. Please choose another size.`);
    else hideError($('#upsell-error'));
    const addBtn = $('#upsell-add');
    if (addBtn) addBtn.textContent = `Add ${second.name} · $${sale}`;
  }

  function updateUpsellScroller() {
    const scroller = $('#upsell-picks');
    const prev = $('#upsell-prev');
    const next = $('#upsell-next');
    if (!scroller || !prev || !next) return;
    const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth - 2);
    prev.disabled = scroller.scrollLeft <= 2;
    next.disabled = scroller.scrollLeft >= max;
  }

  function scrollUpsell(dir) {
    const scroller = $('#upsell-picks');
    if (!scroller) return;
    const card = scroller.querySelector('.upsell-pick');
    const gap = card ? Number.parseFloat(getComputedStyle(scroller).columnGap || '0') : 0;
    const step = Math.round((card?.getBoundingClientRect().width || 0) + gap) || Math.round(scroller.clientWidth * 0.72);
    const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    scroller.scrollLeft = Math.max(0, Math.min(max, scroller.scrollLeft + dir * step));
    updateUpsellScroller();
  }

  function renderUpsellModal() {
    const picks = upsellPicks();
    const picksRoot = $('#upsell-picks');
    if (!picks.length) return false;
    if (!picks.some(p => p.id === state.upsellId)) state.upsellId = picks[0].id;
    if (picksRoot) {
      picksRoot.innerHTML = picks.map(item =>
        `<button class="upsell-pick" type="button" role="option" data-upsell-pick="${item.id}" aria-selected="false" aria-label="${item.name}, ${money(item.price)}">
          <img src="${item.src}" alt="" width="120" height="120">
          <span>${item.name.replace(/^The\s+/, '')}</span>
        </button>`
      ).join('');
    }
    const sizeSel = $('#upsell-size');
    if (sizeSel) sizeSel.innerHTML = '';
    syncUpsellSelection();
    return true;
  }

  function openUpsell() {
    if (!renderUpsellModal()) { openDrawer({ animateShip: true }); return; }
    const scroller = $('#upsell-picks');
    if (scroller) scroller.scrollLeft = 0;
    openModal('#upsell-modal');
    requestAnimationFrame(() => {
      if (scroller) scroller.scrollLeft = 0;
      updateUpsellScroller();
    });
  }

  function skipUpsell() {
    closeModal('#upsell-modal');
    openDrawer({ animateShip: true });
  }

  async function addUpsellFromModal() {
    const second = selectedUpsell();
    const size = $('#upsell-size')?.value;
    const error = $('#upsell-error');
    if (!second) return;
    if (!size) {
      showError(error, `Please choose a size for ${second.name}.`);
      return;
    }
    if (!canBuy(second.id, size)) {
      showError(error, `Size ${size} is sold out in ${second.name}. Please choose another size.`);
      return;
    }
    try {
      state.cart = await cartAdd(variantId(second.id, size), 1, followTryOn());
      hideError(error);
      closeModal('#upsell-modal');
      openDrawer({ animateShip: true });
    } catch (e) {
      if (e.status === 422) {
        markSoldOut(second.id, size);
        syncUpsellSelection();
      }
      showError(error, e.status === 422
        ? `Sorry, size ${size} in ${second.name} just sold out. Please choose another size.`
        : 'Something went wrong. Please try again.');
    }
  }

  function initUpsell() {
    const picksRoot = $('#upsell-picks');
    picksRoot?.addEventListener('click', e => {
      const btn = e.target.closest('[data-upsell-pick]');
      if (!btn) return;
      state.upsellId = btn.dataset.upsellPick;
      syncUpsellSelection();
    });
    picksRoot?.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const picks = upsellPicks();
      const index = Math.max(0, picks.findIndex(p => p.id === state.upsellId));
      const next = e.key === 'ArrowRight' ? Math.min(picks.length - 1, index + 1) : Math.max(0, index - 1);
      if (!picks[next]) return;
      e.preventDefault();
      state.upsellId = picks[next].id;
      syncUpsellSelection();
      picksRoot.querySelector(`[data-upsell-pick="${state.upsellId}"]`)?.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    });
    picksRoot?.addEventListener('scroll', updateUpsellScroller, { passive: true });
    $('#upsell-prev')?.addEventListener('click', () => scrollUpsell(-1));
    $('#upsell-next')?.addEventListener('click', () => scrollUpsell(1));
    window.IR = window.IR || {};
    window.IR.scrollUpsell = scrollUpsell;
    $('#upsell-add')?.addEventListener('click', addUpsellFromModal);
    $('#upsell-size')?.addEventListener('change', () => hideError($('#upsell-error')));
    $$('[data-upsell-skip]').forEach(el => el.addEventListener('click', skipUpsell));
  }

  /* ── sticky ATC ── */

  function initStickyBar() {
    const trigger = $('#primary-atc');
    const bar = $('#sticky-atc');
    if (!trigger || !bar || !('IntersectionObserver' in window)) return;
    const mq = window.matchMedia('(max-width: 899px)');
    const observer = new IntersectionObserver(entries => {
      const hidden = !entries[0].isIntersecting;
      const show = hidden && mq.matches;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky-atc', show);
    }, { threshold: 0 });
    observer.observe(trigger);
    mq.addEventListener('change', () => {
      if (!mq.matches) {
        bar.classList.remove('is-visible');
        document.body.classList.remove('has-sticky-atc');
      }
    });
  }

  /* ── scroll to size ── */

  function initScroll() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-scroll-to-size]');
      if (!btn || btn.closest('#cart-drawer')) return;
      const target = $('#size-selector');
      if (!target) return;
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center'
      });
      focusFirstSize();
    });
  }

  /* ── UGC videos ── */

  function initUgcVideos() {
    const videos = $$('.ugc-video');
    if (!videos.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      videos.forEach(v => { v.pause(); v.removeAttribute('autoplay'); });
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = entry.target;
        video.muted = true;
        entry.isIntersecting ? video.play().catch(() => {}) : video.pause();
      });
    }, { threshold: 0.25 });
    videos.forEach(video => {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      const poster = video.getAttribute('poster');
      if (poster && !video.style.backgroundImage) video.style.backgroundImage = `url("${poster}")`;
      video.addEventListener('error', () => { if (poster) video.style.backgroundImage = `url("${poster}")`; });
      observer.observe(video);
    });
  }

  /* ── attribution & tracking ── */

  const ATTRIBUTION_KEYS = ['fbclid','gclid','gbraid','wbraid','ttclid','msclkid','utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id'];
  const ATTRIBUTION_STORE = 'ir_meta_attr';

  function readCookie(name) {
    const row = document.cookie.split('; ').find(p => p.startsWith(`${name}=`));
    return row ? decodeURIComponent(row.slice(name.length + 1)) : '';
  }

  function writeRootCookie(name, value) {
    if (!value) return;
    const root = /(?:^|\.)iconic-rings\.com$/i.test(location.hostname) ? '; domain=.iconic-rings.com' : '';
    document.cookie = `${name}=${value}; path=/; max-age=7776000; SameSite=Lax${root}`;
  }

  function storedAttribution() {
    let stored = {};
    try { stored = JSON.parse(sessionStorage.getItem(ATTRIBUTION_STORE) || '{}'); } catch (e) { stored = {}; }
    const params = new URLSearchParams(location.search);
    ATTRIBUTION_KEYS.forEach(key => { const v = params.get(key); if (v) stored[key] = v; });
    try { sessionStorage.setItem(ATTRIBUTION_STORE, JSON.stringify(stored)); } catch (e) {}
    return stored;
  }

  function shareMetaCookies() {
    const stored = storedAttribution();
    if (stored.fbclid && !readCookie('_fbc')) writeRootCookie('_fbc', `fb.1.${Date.now()}.${stored.fbclid}`);
    const fbp = readCookie('_fbp'), fbc = readCookie('_fbc');
    if (fbp) writeRootCookie('_fbp', fbp);
    if (fbc) writeRootCookie('_fbc', fbc);
  }

  function trackMeta(event, params) {
    if (typeof window.fbq !== 'function') return;
    window.fbq('track', event, params);
  }

  function gaItem(product, { qty = 1 } = {}) {
    return {
      item_id: String(shopifyProductId(product.id) || product.id),
      item_name: product.name,
      item_category: product.collection || 'Rings',
      price: Number(product.price) || 0,
      quantity: qty
    };
  }

  function trackGa(event, params) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', event, params);
  }

  function metaItemPayload(product, { size, qty = 1 } = {}) {
    const id = String(shopifyProductId(product.id) || product.id);
    const value = Number(product.price) || 0;
    return {
      content_ids: [id],
      content_type: 'product_group',
      content_name: product.name,
      content_category: product.collection || 'Rings',
      value,
      currency: 'USD',
      contents: [{ id, quantity: qty, item_price: value }]
    };
  }

  function trackViewContent() {
    const product = currentProduct();
    const payload = metaItemPayload(product, { size: state.size || undefined });
    trackMeta('ViewContent', payload);
    trackGa('view_item', { currency: 'USD', value: payload.value, items: [gaItem(product)] });
  }

  function trackTripleAdd(id, size, qty) {
    if (typeof window.TriplePixel !== 'function' || !qty || qty < 1) return;
    const productId = shopifyProductId(id);
    const vid = variantId(id, size);
    if (!productId || !vid) return;
    window.TriplePixel('AddToCart', { item: String(productId), q: qty, v: String(vid) });
  }

  /* ── Klaviyo newsletter ── */

  function initNewsletter() {
    const form = $('#newsletter-form');
    if (!form) return;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const emailInput = form.querySelector('[name="email"]');
      const email = emailInput?.value.trim();
      if (!email) return;
      const key = data.klaviyo?.publicKey || '';
      const listId = data.klaviyo?.listId || '';
      const successEl = $('#newsletter-success');
      const show = () => { form.hidden = true; if (successEl) successEl.hidden = false; };
      if (!key) { show(); return; }
      try {
        await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(key)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                list_id: listId,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email }
                  }
                }
              }
            }
          })
        });
      } catch (_) {}
      show();
    });
  }

  /* ── boot ── */


  getCart().then(cart => {
    state.cart = cart;
    updateCartCount();
  }).catch(() => {});

  renderGallery();
  renderSizes();
  renderVariants();
  renderSizeTable();
  renderRatingSummary();
  updatePage();
  updateSelectedSize();
  trackViewContent();
  shareMetaCookies();
  window.setTimeout(shareMetaCookies, 800);
  initAnnouncement();
  initGallery();
  initVariants();
  initSizes();
  initModal();
  initAccordions();
  initCart();
  initUpsell();
  initStickyBar();
  initScroll();
  initUgcVideos();
  initNewsletter();
})();
